import { api_GET, api_POST, api_PUT, api_POST_Unauthorize } from "../api/_axios.js";

const usuario_api =
{
    getAll: function () {
        const promise = new Promise((resolve, reject) => {
            api_GET(`usuario`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getFiscais: function () {
        const promise = new Promise((resolve, reject) => {
            api_GET(`usuario/getFiscais`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getItem: function (id) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`usuario/getItem/${id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getPerfisCadastro: function () {
        const promise = new Promise((resolve, reject) => {
            api_GET(`usuario/getPerfisCadastro`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getFuncionalidades: function (perfil) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`usuario/getFuncionalidades/${perfil}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getCodigoFuncionalidadesUsuario: function () {
        const promise = new Promise((resolve, reject) => {
            api_GET(`usuario/GetCodigoFuncionalidadesUsuario`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getFuncionalidadeAcaoLiberada: function (funcionalidade, acao) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`usuario/getFuncionalidadeAcaoLiberada/${funcionalidade}/${acao}`).then(result => {
                if (result.status == 200)
                    resolve(result.data);
                else
                    resolve(false);
            });
        });

        return promise;
    },

    post: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`usuario`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    put: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`usuario`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },


    authenticate: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST_Unauthorize(`authenticate`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    esqueceu_senha: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST_Unauthorize(`authenticate/EsqueceuSenha`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    trocar_senha: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`usuario/TrocarSenha`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    }
}

export default usuario_api
